import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
const baseUrl = `${BASE_URL}/crm`;

const getBadgeMaster = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/badge-master/get-badge-master-detail`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};

export { getBadgeMaster };
